module.exports = __webpack_public_path__ + "assets/img/dac54e3435c9a1ad80d490bf04a49fbc.svg";